/**
 * 路由层
 */

import React from 'react';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import { url } from '@/url';
import { Home } from '@/view/home';
import { Label } from '@/view/label';
import { ReportView } from './view/report';

// 路由工厂函数
interface RouteFactory {
  (routenHelper: {
    params: Record<string, any>; // URL 匹配参数（不包括 ? 后的查询参数）
  }): JSX.Element;
}

const routeConfig: [string, RouteFactory][] = [
  // 主页
  [url.home(), () => <Home />],
  // 标注页入口
  [
    url.label({
      // 声明动态参数
      type: ':type',
      gender: ':gender',
      c1: ':c1',
      c2: ':c2',
    }),
    ({ params: { type, gender, c1, c2 } }) => <Label type={type} gender={gender} c1={c1} c2={c2} />,
  ],
  [url.report(), () => <ReportView />],
];

export const AppRoutes = () => {
  const routes = routeConfig.map(([path, factory]) => {
    return (
      <Route
        key={path}
        path={path}
        exact
        render={({ match: { params } }) => {
          return factory({ params });
        }}
      />
    );
  });

  return (
    <Router>
      <Switch>
        {routes}
        <Redirect to={routeConfig[0][0]} />
      </Switch>
    </Router>
  );
};
